import React from 'react';
import PropTypes from 'prop-types';
import { Field, Form } from 'redux-form';

import { checkButtonDisabled } from '../../utils/forms';

import AccountCCEmail from './AccountCCEmail';
import InputField from '../shared/InputField';

export default class ManageEmailsForm extends React.Component {
  static propTypes = {
    accountId: PropTypes.number.isRequired,
    accountCCEmails: PropTypes.object.isRequired,
    cancelFunction: PropTypes.func.isRequired,
    createAccountCCEmailFunction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    removeAccountCCEmailFunction: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit = params => {
    const { createAccountCCEmailFunction } = this.props;
    createAccountCCEmailFunction(params);
  };

  renderEmail = accountEmail => {
    const { removeAccountCCEmailFunction } = this.props;
    const { email, id } = accountEmail;
    return (
      <AccountCCEmail key={id} email={email} id={id} removeEmail={removeAccountCCEmailFunction} />
    );
  };

  render() {
    const {
      accountId,
      accountCCEmails,
      cancelFunction,
      handleSubmit,
      invalid,
      pristine,
      submitting,
    } = this.props;

    return (
      <div className="modal-body">
        <div className="container">
          <p>
            {accountId > 1 ? (
              <i>Additional email addresses will be CC&#39;ed in order confirmation emails.</i>
            ) : (
              <i>
                Additional email addresses will be BCC&#39;ed in all provider order confirmation
                emails.
              </i>
            )}
          </p>
          {accountCCEmails.size > 0 ? (
            <div>{accountCCEmails.map(this.renderEmail)}</div>
          ) : (
            <p>This account has no additional emails to {accountId > 1 ? 'CC' : 'BCC'}</p>
          )}
          <Form id="loginForm" onSubmit={handleSubmit(this.submit)}>
            <fieldset>
              <Field
                name="email"
                component={InputField}
                type="text"
                placeholder="example@exampledomain.com"
                label="Email Address"
              />
            </fieldset>
            <div className="modal-footer">
              <button type="button" className="btn btn-link" onClick={cancelFunction}>
                Close
              </button>&nbsp;
              <button
                type="submit"
                className="btn btn-primary btn-login"
                disabled={checkButtonDisabled(invalid || pristine, submitting)}
              >
                Add
              </button>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}
